const _excluded = ["name", "description", "variablePriceText"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { IconButton, RichTextViewer, Typography, useGlobalContext } from 'seagull';
import { InfoLiner12 } from 'seagull/icons';
import styles from "./ServiceItem.module.scss";
import { ResponsiveModal } from "../../components/ResponsiveModal";
import { useResponsive } from "../../contexts";
export default function ServiceItem(_ref) {
  let {
      name,
      description,
      variablePriceText
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const globalContext = useGlobalContext();
  const {
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/React.createElement("li", {
    className: styles.serviceDetails,
    "data-testid": props['data-testid']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.nameContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3"
  }, name, description && /*#__PURE__*/React.createElement(IconButton, {
    noPadding: true,
    skin: "transparent",
    className: styles.icon,
    "data-testid": "".concat(props['data-testid'], "-tooltip"),
    onClick: () => {
      globalContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/React.createElement(ResponsiveModal, {
            isDesktop: isDesktop,
            title: "".concat(name, " description"),
            backTitle: "Back to packages",
            primaryButtonLabel: "Close",
            onPrimaryButtonClick: dismissModal,
            onClose: dismissModal
          }, /*#__PURE__*/React.createElement(RichTextViewer, {
            value: description
          }));
        }
      });
    }
  }, /*#__PURE__*/React.createElement(InfoLiner12, null)))), variablePriceText && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3",
    style: {
      textAlign: 'end'
    },
    "data-testid": "".concat(props['data-testid'], "-price")
  }, variablePriceText));
}